export enum RecordTransferType {
	deposit = 0,
	withdraw = 1,
}

export enum RecordTransferOuterStatus {
	canceled = 0,
	processing = 1, // 处理中 - 出金可以取消
	success = 2,
	failed = 3,
	unfinished = 4, // 未完成 - 入金可以取消
}

export type DepositProgressStatusValue =
	| "submitted"
	| "processing"
	| "completed"
	| "cancelled"
	| "canceled";

export interface TransferRecord {
	userId: number;
	transferId: string;
	amount: string;
	currency: string;
	status: RecordTransferOuterStatus;
	transferType: RecordTransferType;
	createTime: string;
	updateTime: string;
	ext?: string;
	depositProgressStatus?: DepositProgressStatusValue;
	isDepositOverdue?: boolean;
}

export interface RecordQueryParams {
	type?: number;
	startDate?: string;
	endDate?: string;
	status?: number;
	month?: string;
}

export interface DepositRecord {
	depositId: string;
	userId: number;
	masterAccountId: string;
	depositBankAccountId: string;
	currency: string;
	amount: number;
	actualAmount: number;
	receiptImages: string[];
	status: number;
	type: number;
	thirdPartyId: string;
	thirdPartyOrderId: string;
	depositTime: number;
	applyTime: number;
	createTime: number;
	updateTime: number;
	masterAccountNameLocal: string;
	subAccountId: string;
	channelType: number;
	recordedCurrency: string;
	recordedAmount: number;
	originalCurrency: string;
}

export interface OrderInfo {
	order: Order;
	cardInfo?: CardInfo;
}

interface Order {
	id: number;
	userId: number;
	orderId: string;
	transactionId: string;
	price: number;
	currency: string;
	orderStatus: number;
	companyCode: string;
	appId: number;
	remark: string;
	region: string;
	createTime: number;
	updateTime: number;
	actualPrice: number;
	actualCurrency: string;
	handlingFeeRatio: number;
	customer: string;
	channelCode: string;
	cardId: string;
	errorCode: string;
}

interface CardInfo {
	id: number;
	cardId: string;
	userId: number;
	companyCode: string;
	name: string;
	sourceId: string;
	cardMask: string;
	fingerprint: string;
	bin: string;
	expireMonth: string;
	expireYear: string;
	cardType: string;
	cardCategory: string;
	scheme: string;
	issuer: string;
	issuerCountry: string;
	cardStatus: number;
	cardExpired: boolean;
	availability: boolean;
	createTime: number;
	updateTime: number;
}

export interface TransferRecordDetailRes extends TransferRecord {
	detail?: any;
	orderInfo?: OrderInfo;
	cardInfo?: CardInfo;
}
